import PersonalMinimumsConst from '../../../constants/personalminimums.constant';

export const personalMinimumsState = {
  typesOfPersonalMinimums: PersonalMinimumsConst.typesOfMin,
  allPersonalMinimums: PersonalMinimumsConst.minimumsList,
  personalMinimumsCurrentFilter: PersonalMinimumsConst.typesOfMin.minimums,
};
